import { render, staticRenderFns } from "./gj-area-title.vue?vue&type=template&id=28172610&scoped=true&"
import script from "./gj-area-title.vue?vue&type=script&lang=js&"
export * from "./gj-area-title.vue?vue&type=script&lang=js&"
import style0 from "./gj-area-title.vue?vue&type=style&index=0&id=28172610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28172610",
  null
  
)

export default component.exports